import { useSearchParams } from "react-router-dom";
import { Ban, RotateCcw } from "lucide-react";
import PaymentStatusShell from "./PaymentStatusShell";
import PaymentSuccess from "./PaymentSuccess";
import { getPaymentQueryData } from "./paymentStatusQuery";

export default function PaymentCancel() {
  const [searchParams] = useSearchParams();
  const { paySystemName, status, transactionID } = getPaymentQueryData(searchParams);
  const orderId = searchParams.get("orderId");

  // EPS returns through the API, which re-checks the payment with EPS before
  // redirecting — a payment EPS confirms was collected is shown as paid.
  if (status === "paid" || status === "refunded") return <PaymentSuccess />;

  // The order was created (and the cart emptied) before the gateway opened, so
  // paying later happens from that order rather than a new checkout.
  const payHref = orderId ? `/order-details/${encodeURIComponent(orderId)}` : "/my-orders";

  return (
    <PaymentStatusShell
      icon={<Ban size={40} />}
      tone="warning"
      badge="Payment Cancelled"
      title="Payment Cancelled"
      subtitle={`Your payment via ${paySystemName || "the selected method"} was cancelled. Your order is saved — you can pay for it whenever you're ready.`}
      transactionID={transactionID}
      note="If this was accidental, open your order and pay from there."
      actions={
        <>
          <a href={payHref} className="ps-btn ps-btn-primary">
            <RotateCcw size={15} /> Pay for Order
          </a>
          <a href="/" className="ps-btn ps-btn-outline">
            Return Home
          </a>
        </>
      }
    />
  );
}
